import React from "react";
import Particles from "react-tsparticles";

function ParticleBG() {
  return (
    <Particles
      options={{
        background: {
          color: {
            value: "#171615",
          },
        },
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 1500,
            },
          },

          color: {
            value: "#bf844d",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#bf844d",
            },
            polygon: {
              nb_sides: 5,
            },
            image: {},
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 5,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 170,
            color: "#bf3600",
            opacity: 0.3,
            width: 1.6,
          },
          move: {
            enable: true,
            speed: 1.3,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "window",
          events: {
            onhover: {
              enable: false,
              mode: "grab",
            },
            onclick: {
              enable: false,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: false,
      }}
      style={{
        backgroundColor: "#171615",
        position: "absolute",
        left: "0",
        top: "0",
        height: "100vh",
      }}
    />
  );
}
export default ParticleBG;
